import React, { useState, useEffect, useCallback, useReducer } from 'react';
import { useHistory } from "react-router-dom";
import UserSearchBar from '../userSearchBar/UserSearchBar';
import paramSetterReducer from 'utils/customReducer/paramSetterReducer';
import Table from 'utils/table/Table';
import { Styles } from 'utils/table/Table.css.js';

import { columnSetter }from './columns';
import { makeDataLevel } from './makeDataLevel';
import { customAxiosGetFunction, customAxiosPostFunction } from 'utils/axiosFunction';
import { nvl } from 'utils/nvl';

const UserDetailTable = ({ auths }) => {
  const history = useHistory();
  const [ data, setData ] = useState([]);
  const [ columns, setColumns ] = useState(columnSetter());
  const [ paramState, dispatch ] = useReducer(paramSetterReducer, 
                                              {
                                                pageIndex: 0,
                                                pageCount: 0,
                                                pageSize: 15,
                                                elementCount: 0,
                                                canNextPage: false,
                                                canPreviousPage: false
                                              })

  const setTableData = useCallback(async () => {
    customAxiosGetFunction(history, '/api/user/getDatas', {params: {...paramState}}).then(response => {
      if(nvl(response, null) === null) {
        return false;
      }

      dispatch({type: 'CHANGE_TOTAL', pageCount: response.totalPages, elementCount: response.totalElements});
      dispatch({type: 'CHANGE_CANPAGE', canNextPage: !response.last, canPreviousPage: !response.first});
      setData(
        nvl(response.content, []).map((d, index) => {
          return {
            ...makeDataLevel(
              d,
              paramState.pageIndex,
              paramState.pageSize,
              index
            )
          }
        })
      );
    })
  }, [paramState])

  const deleteUser = useCallback( async (userIdx) => {
    if (!window.confirm('계정이 삭제됩니다.\n계속 진행하시겠습니까?')) {
      return false;
    }

    customAxiosPostFunction(history, '/api/user/deleteUser', {userIdx: userIdx})
      .then(response => {
        if (response === 1) {
          alert(`삭제완료`);
          setTableData();
        }
        else {
          alert(`삭제실패`);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    setTableData();
    setColumns(columnSetter(setTableData, deleteUser, auths));
  }, [paramState.pageIndex])

  return (
    <>
      <UserSearchBar auths={auths} 
                     setTableData={setTableData}
                     userCounts={data.length} />
      <Styles>
        <Table 
          columns={columns} 
          data={data} 
          setParamDispatch={dispatch}
          {...paramState}
        />
      </Styles>
    </>
  )
}

export default UserDetailTable;